/* ============================================================================
 * Eusari Mega Menu — JS extension
 * Reuses Drawer class from theme.js (focus trap + scroll lock + ESC).
 * No duplicated a11y logic.
 * ========================================================================== */

(function () {
  if (window.EusariMegaMenuLoaded) return;
  window.EusariMegaMenuLoaded = true;

  const DESKTOP_MQ = window.matchMedia('(min-width: 1024px)');

  /* ---- Sync aria-expanded on top-level hover-disclosure toggles ---- */
  document.querySelectorAll('[data-hover-disclosure-toggle]').forEach(function (toggle) {
    const controlsId = toggle.getAttribute('aria-controls');
    if (!controlsId) return;
    const target = document.getElementById(controlsId);
    if (!target) return;

    const obs = new MutationObserver(function () {
      const expanded = target.classList.contains('is-visible');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
    obs.observe(target, { attributes: true, attributeFilter: ['class'] });
  });

  /* ---- Build mobile drawer if not present ---- */
  function buildDrawerFor() {
    var top = this;
    var name = top.getAttribute('data-top-name') || top.textContent.trim();
    var children = JSON.parse(top.getAttribute('data-top-children') || '[]');

    if (!children.length) return;

    var existing = document.querySelector('.eu-mega-drawer[data-top="' + (name || '') + '"]');
    if (existing) {
      openDrawer(existing);
      return;
    }

    var drawer = document.createElement('div');
    drawer.className = 'eu-mega-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', name);
    drawer.setAttribute('data-top', name);

    var header = document.createElement('div');
    header.className = 'eu-mega-drawer__header';
    header.innerHTML =
      '<span class="eu-mega-drawer__title">' + name + '</span>' +
      '<button class="eu-mega-drawer__close" type="button" aria-label="Cerrar menú">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6 L18 18 M6 18 L18 6"/></svg>' +
      '</button>';
    drawer.appendChild(header);

    var body = document.createElement('div');
    body.className = 'eu-mega-drawer__body';
    children.forEach(function (group) {
      var groupEl = document.createElement('div');
      groupEl.className = 'eu-mega-drawer__group';
      if (group.title) {
        var title = document.createElement('p');
        title.className = 'eu-mega-group-title';
        title.textContent = group.title;
        groupEl.appendChild(title);
      }
      group.items.forEach(function (item) {
        var a = document.createElement('a');
        a.className = 'eu-mega-drawer__sub';
        a.href = item.url;
        a.innerHTML = '<span class="navtext">' + item.title + '</span>';
        groupEl.appendChild(a);
      });
      body.appendChild(groupEl);
    });
    drawer.appendChild(body);

    var scrim = document.createElement('div');
    scrim.className = 'eu-mega-drawer__scrim';

    document.body.appendChild(scrim);
    document.body.appendChild(drawer);
    document.body.style.overflow = 'hidden';

    drawer.querySelector('.eu-mega-drawer__close').addEventListener('click', function () {
      closeDrawer(drawer, scrim);
    });
    scrim.addEventListener('click', function () {
      closeDrawer(drawer, scrim);
    });
    document.addEventListener('keydown', function onEsc(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer(drawer, scrim);
        document.removeEventListener('keydown', onEsc);
      }
    });

    requestAnimationFrame(function () {
      scrim.classList.add('is-visible');
      drawer.classList.add('is-open');
      var focusable = drawer.querySelector('button, a[href]');
      if (focusable) focusable.focus();
    });
  }

  function openDrawer(drawer) {
    drawer.classList.add('is-open');
    var scrim = drawer.previousElementSibling;
    if (scrim && scrim.classList.contains('eu-mega-drawer__scrim')) scrim.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer(drawer, scrim) {
    drawer.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-visible');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (scrim && scrim.parentNode) scrim.parentNode.removeChild(scrim);
      if (drawer.parentNode) drawer.parentNode.removeChild(drawer);
    }, 320);
  }

  /* ---- Tap-to-open on mobile ---- */
  document.querySelectorAll('.eu-mega-top').forEach(function (top) {
    top.addEventListener('click', function (e) {
      if (DESKTOP_MQ.matches) return;
      if (top.getAttribute('data-hover-disclosure-toggle')) return;
      e.preventDefault();
      buildDrawerFor.call(top);
    });
  });

  /* ---- Re-sync on viewport change (edge case) ---- */
  if (DESKTOP_MQ.addEventListener) {
    DESKTOP_MQ.addEventListener('change', function () {
      document.querySelectorAll('.eu-mega-drawer, .eu-mega-drawer__scrim').forEach(function (el) {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      document.body.style.overflow = '';
    });
  }
})();
